import { render } from "./ServicesDGII.vue?vue&type=template&id=c3d07a06"
import script from "./ServicesDGII.vue?vue&type=script&lang=js"
export * from "./ServicesDGII.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__